/** User-visible reasons when a layout section does not show normal campaign content. */

export const SECTION_SUPPRESSION_LOW_CAPACITY_HLS
  = 'Live stream (HLS) playback is disabled on this player because hardware capacity is set to low.'

export const SECTION_SUPPRESSION_LOW_CAPACITY_VIDEO
  = 'Video playback is disabled on this player because hardware capacity is set to low. Images and widgets still play.'

export const SECTION_SUPPRESSION_NO_ASSET
  = 'No asset is assigned to this section.'

export const SECTION_SUPPRESSION_ASSET_UNAVAILABLE
  = 'This media is not loaded or is unavailable for playback.'

export const SECTION_SUPPRESSION_WIDGET_NO_URL
  = 'Widget has no playable URL after applying configuration (check required URL parameters).'

export const SECTION_SUPPRESSION_UNSUPPORTED
  = 'This section cannot be rendered (unsupported or missing content).'

export const SECTION_SUPPRESSION_NOT_READY
  = 'This content is not ready to display (still processing or missing renderer).'

/** Visible when HTMLMediaElement fires `error` or decode fails (field diagnosis vs a black frame). */
export const SECTION_PLAYBACK_VIDEO_GENERIC
  = 'Video playback failed.'

export const SECTION_PLAYBACK_VIDEO_NETWORK
  = 'Video failed to load (network error).'

export const SECTION_PLAYBACK_VIDEO_DECODE_OR_FORMAT
  = 'Video failed to decode or this format is not supported on this device.'

/** HLS.js path: MSE not available in this WebView/browser. */
export const SECTION_PLAYBACK_HLS_NOT_SUPPORTED_IN_WEBVIEW
  = 'Live stream (HLS) cannot play here because adaptive streaming (MSE) is not supported in this WebView.'

/** HLS.js fatal error (network, media, manifest). */
export const SECTION_PLAYBACK_HLS_STREAM_ERROR
  = 'Live stream failed (network, decode, or stream error). Check connection and the stream.'
